import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';

function useHovered() {
  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      hovered = _useState2[0],
      setHovered = _useState2[1];

  var resetHovered = function resetHovered() {
    return setHovered(-1);
  };

  return [hovered, {
    setHovered: setHovered,
    resetHovered: resetHovered
  }];
}

export { useHovered };